import { type FC, memo, useState } from 'react'
import ClipContainer from './ClipContainer'
import type { Clip } from '@/features/clips/domain/models/clip.ts'
import ContextMenu, {
  type ContextMenuState,
} from '../../../common/ContextMenu.tsx'
import { createPortal } from 'react-dom'
import Icon from '../../../common/Icon.tsx'
import { deleteClip } from '@/features/clips/domain/use-cases/delete-clip.ts'
import { downloadClip } from '@/utils/download-clip.ts'
import { cutClip } from '@/shared/store/use-cases/cut-clip.ts'
import { movePlaybackLineToClick } from '@/shared/store/use-cases/move-playback-line-to-click.ts'
import { useTracking } from '@/providers/TrackingProvider.tsx'

interface SoundDesignClipProps {
  clip: Clip
}

const SoundDesignClip: FC<SoundDesignClipProps> = ({ clip }) => {
  const [contextMenuState, setContextMenuState] = useState<ContextMenuState>({
    isOpen: false,
    position: { left: 0, top: 0 },
  })
  const { trackEvent } = useTracking()

  return (
    <div
      onContextMenu={(e) => {
        e.preventDefault()
        e.stopPropagation()
        movePlaybackLineToClick(e)
        setContextMenuState({
          isOpen: true,
          position: { left: e.clientX + 2, top: e.clientY },
        })
      }}
    >
      <ClipContainer clip={clip} />
      {contextMenuState.isOpen &&
        createPortal(
          <ContextMenu
            isOpen={contextMenuState.isOpen}
            setIsOpen={(isOpen: boolean) =>
              setContextMenuState((prev) => ({ ...prev, isOpen }))
            }
            position={contextMenuState.position}
            viewModel={[
              {
                key: 'Split',
                action: () => cutClip(clip),
                icon: <Icon name="cut" />,
              },
              {
                key: 'Download',
                action: () => downloadClip(clip, trackEvent),
                icon: <Icon name="download" fill="white" />,
              },
              {
                key: 'Delete',
                action: () => deleteClip(clip),
                icon: <Icon name="xMark" />,
              },
            ]}
          />,
          document.body
        )}
    </div>
  )
}

export default memo(SoundDesignClip)
